/**
 * ModuleName: adapterRequest
 * Description: 迅雷盒子设备远程模块接口适配器类实例化单例
 *
 * @author : lushaoqing
 * @date : 2022/12/06 16:00
 */

import AdapterRequest from './adapter-request'
import {
  mock,
  addHeadersTarget,
  interceptGetDeviceList,
  interceptGetResourceList,
  interceptCreateTask,
  interceptActionTask,
} from './interceptors/request'
import { 
  adapterGetNfosHander,
  // adapterGetFileInfoHander,
} from './interceptors/response'

const requestInterceptors = [
  mock,
  addHeadersTarget,
  interceptGetDeviceList,
  interceptGetResourceList,
  interceptCreateTask,
  interceptActionTask,
]
const responseInterceptors = [
  adapterGetNfosHander,
  // adapterGetFileInfoHander,
]
const adapterRequest = new AdapterRequest(requestInterceptors, responseInterceptors)

export default adapterRequest.request